import React from 'react';
import "./SearchPage.css";
import { useStateValue } from "../StateProvider";
import useGoogleSearch from '../useGoogleSearch';
import Response from "../response";
import { Link } from "react-router-dom";
import Search from '../components/Search';
import SearchIcon from "@material-ui/icons/Search";
import DescriptionIcon from "@material-ui/icons/Description";
import ImageIcon from "@material-ui/icons/Image";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import RoomIcon from "@material-ui/icons/Room";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import AppsIcon from '@material-ui/icons/Apps';
import { Avatar, IconButton } from '@material-ui/core';
import Footer from "../components/Footer";


function SearchPage() {

    const [{ term }, dispatch] = useStateValue();

    // LIVE API CALL
    const { data } = useGoogleSearch(term);

    // MOCK data to preserve the quota for API calls
    // const data = Response;

    console.log(data);

    return (
        <div className="searchPage">
            <div className="searchPage__header">

                <div className="searchPage__headerLeft">
                    <Link to="/">
                        <img className="searchPage__logo"
                            src="https://fontmeme.com/permalink/201011/d2bd0a10549d22272b4db462403f19b7.png"
                            alt="custom_logo"
                        />
                    </Link>

                    <div className="searchPage__headerBody">


                        <Search hideButtons />

                        <div className="searchPage__options">
                            <div className="searchPage__optionsLeft">
                                <div className="searchPage__option searchPage__optionSelected">
                                    <SearchIcon />
                                    <Link to="/all" className="searchPage__optionSelected">All</Link>
                                </div>
                                <div className="searchPage__option">
                                    <DescriptionIcon />
                                    <Link to="/news">News</Link>
                                </div>
                                <div className="searchPage__option">
                                    <ImageIcon />
                                    <Link to="/images">Images</Link>
                                </div>
                                <div className="searchPage__option">
                                    <RoomIcon />
                                    <Link to="/maps">Maps</Link>
                                </div>
                                <div className="searchPage__option">
                                    <LocalOfferIcon />
                                    <Link to="/shop">Market</Link>
                                </div>
                                <div className="searchPage__option">
                                    <MoreVertIcon />
                                    <Link to="/more">More</Link>
                                </div>
                            </div>
                            <div className="searchPage__optionsRight">
                                <div className="searchPage__option">
                                    <Link to="/settings">Settings</Link>
                                </div>
                                <div className="searchPage__option">
                                    <Link to="/tools">Tools</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="searchPage__headerRight">
                    <IconButton>
                        <AppsIcon className="home__headerRightappIcon" />
                    </IconButton>
                    <Avatar src="https://cdn3.iconfinder.com/data/icons/generic-avatars/128/avatar_portrait_man_male-128.png" />
                </div>

            </div>

            {/* if there is a search term */}
            {term && (
                <div className="searchPage__results">
                    <p className="searchPage__resultCount">About {data?.searchInformation.formattedTotalResults} results ({data?.searchInformation.formattedSearchTime} seconds) for {term} </p>

                    {data?.items.map(item => (
                        <div className="searchPage__result">
                            <a className="searchPage__resultLink" href={item.link}>
                                {item.displayLink} <small>▼</small>
                            </a>
                            <a className="searchPage__resultTitle" href={item.link}>
                                <h3>{item.title}</h3>
                            </a>

                            <p className="searchPage__resultSnippet">

                                {item.snippet}</p>
                        </div>
                    ))}


                </div>
            )}

            <Footer />

        </div>
    )
}

export default SearchPage;
